import RequireData from "hooks/RequireData";
import React from "react";
import jobTasks from "selectors/jobTasks";
import jobTasksStatus from "selectors/jobTasksStatus";
import JobDetailTaskGraphicSquare from "./JobDetailTaskGraphicSquare";
import styles from "./JobDetailTaskGraphic.module.scss";
import { useDispatch, useSelector } from "react-redux";
import jobTasksUpdatedAtSelector from "selectors/jobTasksUpdatedAt";
import SageErrorAlert from "kit/SageErrorAlert";

interface Props {
    jobID: string;
}

const JobDetailTaskGraphic: React.FC<Props> = ({ jobID }) => {
    const dispatch = useDispatch();
    const [tasks, status] = RequireData(
        jobTasks(jobID),
        jobTasksStatus(jobID),
        {
            type: "com.sage.actions.jobs.IFetchJobTasksUpdated",
            jobID,
            updatedAt: null,
        } as sage.actions.jobs.IFetchJobTasksUpdated
    );

    const hasUnfinishedTask = React.useMemo(() => {
        for (const task of tasks || []) {
            if (
                task.curr_state !== "FINISHED" &&
                task.curr_state !== "CANCELLED"
            ) {
                return true;
            }
        }
        return false;
    }, [tasks]);

    const updatedAt = useSelector(jobTasksUpdatedAtSelector(jobID));

    React.useEffect(() => {
        if (updatedAt && hasUnfinishedTask) {
            const interval = setInterval(() => {
                dispatch({
                    type: "com.sage.actions.jobs.IFetchJobTasksUpdated",
                    jobID: jobID,
                    updatedAt: updatedAt,
                } as sage.actions.jobs.IFetchJobTasksUpdated);
            }, 5000);
            return () => clearInterval(interval);
        }
    }, [dispatch, jobID, updatedAt, hasUnfinishedTask]);

    if (status === "error") {
        return <SageErrorAlert />;
    }

    if (status === "loading" || !tasks) {
        // TODO: Shimmer loading state
        return null;
    }

    return (
        <div>
            <h4>Tasks</h4>
            <div className={styles.squareContainer}>
                {(tasks || []).map((t) => (
                    <JobDetailTaskGraphicSquare task={t} key={t.id} />
                ))}
            </div>
        </div>
    );
};

export default JobDetailTaskGraphic;
